module.exports = __webpack_public_path__ + "img/gateway6.8a00f1ce.png";